import { ConnectorCapability, ExternalItemType } from "@axio/graphql/generated/graphql";
import type { PickerContext } from "../../components/common/general/ContentPicker/ContentPicker.types";

export const STUDENT_ASSIGNMENT_CONTEXT: PickerContext = {
  allowedItemTypes: [ExternalItemType.File, ExternalItemType.Page, ExternalItemType.Folder],
  requiredCapabilities: [ConnectorCapability.Browse, ConnectorCapability.Ingest],
};

export const ADMIN_KNOWLEDGE_BASE_CONTEXT: PickerContext = {
  allowedItemTypes: [ExternalItemType.File, ExternalItemType.Page, ExternalItemType.Folder],
  requiredCapabilities: [ConnectorCapability.Browse, ConnectorCapability.Ingest],
};

export const DEFAULT_CONTEXT: PickerContext = {
  allowedItemTypes: Object.values(ExternalItemType),
  requiredCapabilities: [ConnectorCapability.Browse, ConnectorCapability.Ingest],
};
